<template>
  <div>
    <create-card route_back="EconomicGroups" model_name="grupo econômico" :saving="loading.saving">
      <template slot="form">
        <v-form ref="form" lazy-validation>
          <v-stepper v-model="stepper_count" vertical class="ma-5 elevation-0">
            <v-stepper-step :editable="stepper_count > 1" :complete="stepper_count > 1" step="1" >
              Nome
              <small>Informe o nome do grupo econômico</small>
            </v-stepper-step>
            <v-stepper-content :complete="stepper_count > 1" step="1">
              <v-form ref="forms1">
                <v-text-field v-model="economic_group.name" label="Nome" prepend-icon="mdi-form-textbox" :rules="[rules.required]"/>
              </v-form>
              <div>
                <v-btn text disabled><v-icon large color="red darken-2">mdi-arrow-up-bold</v-icon></v-btn>
                <v-btn text @click="nextStepper(2)" ><v-icon large color="green darken-2">mdi-arrow-down-bold</v-icon></v-btn>
              </div>
            </v-stepper-content>

            <v-stepper-step :editable="stepper_count > 2" :complete="stepper_count > 2" step="2" >
              Créditos e Limites
              <small>Configure o limite de crédito e prazo para bloqueio</small>
            </v-stepper-step>
            <v-stepper-content :complete="stepper_count > 2" step="2">
              <EconomicGroupCreditForm ref="forms2" :economic_group_credit="economic_group.economic_group_credit_attributes" :readonly="false"/>
              <div>
                <v-btn text @click="stepper_count = 1"><v-icon large color="red darken-2">mdi-arrow-up-bold</v-icon></v-btn>
                <v-btn text @click="nextStepper(3)" ><v-icon large color="green darken-2">mdi-arrow-down-bold</v-icon></v-btn>
              </div>
            </v-stepper-content>

            <v-stepper-step :editable="stepper_count > 3" :complete="stepper_count > 3" step="3" >
              Clientes do Grupo
              <small>Selecione ao menos 2 clientes</small>
            </v-stepper-step>
            <v-stepper-content :complete="stepper_count > 3" step="3">
              <EconomicGroupSelectClients ref="forms3" :economic_group="economic_group" :set_clients="set_clients"/>
              <div>
                <v-btn text @click="stepper_count = 2"><v-icon large color="red darken-2">mdi-arrow-up-bold</v-icon></v-btn>
                <f-btn save @click="postEconomicGroup"></f-btn>
              </div>
            </v-stepper-content>

          </v-stepper>
        </v-form>
      </template>
    </create-card>
  </div>
</template>

<script>
import Api from '@/api/index';

export default {
  name: "CreateEconomicGroup",
  components: {
    CreateCard: () => import("@/_backoffice/_registrations/components/shared/create/CreateCard.vue"),
    EconomicGroupSelectClients: () => import("./forms/EconomicGroupSelectClients.vue"),
    EconomicGroupCreditForm: () => import("./forms/EconomicGroupCreditForm.vue"),
  },
  data() {
    return {
      loading: { saving: false },
      dialog: true,
      stepper_count: 1,
      set_clients: false,
      economic_group: {
        name: "",
        client_ids: [],
        economic_group_credit_attributes: {
          limit_aux: '0,00',
          limit: 0,
          original_limit: 0,
          blockingTime: 0,
          status_id: 1,
        },
      },
      rules: {
        required: v => !!v || 'Obrigatório',
        minTwoClients: v => (v && v.length >= 2) || 'Selecione ao menos 2 clientes',
      }
    }
  },
  methods: {
    postEconomicGroup(){
      if(!this.$refs.forms1.validate()) return
      if(!this.$refs.forms2.validate()) return
      if(!(this.economic_group.client_ids && this.economic_group.client_ids.length >= 2)){
        this.$toast && this.$toast.error('Selecione ao menos 2 clientes')
        return
      }
      let limitValue = this.economic_group.economic_group_credit_attributes.limit_aux.toString().replace(/\./g, '').replace(',', '.')
      let economic_group = {
        ...this.economic_group,
        economic_group_credit_attributes: {
          ...this.economic_group.economic_group_credit_attributes,
          limit: parseFloat(limitValue) || 0,
          original_limit: parseFloat(limitValue) || 0,
        }
      }
      
      this.loading.saving = true
      Api.EconomicGroup.create(economic_group).then(()=>{
        this.successSaved()
        this.stepper_count = 1
        this.economic_group = { 
          name: '', 
          client_ids: [],
          economic_group_credit_attributes: {
            limit_aux: '0,00',
            limit: 0,
            original_limit: 0,
            blockingTime: 0,
            status_id: 1,
          }
        }
        this.set_clients = false
      }).catch(() => {
        this.errorUpdated()
      }).finally(()=>{
        this.loading.saving = false
      })
    },
    nextStepper(number){
      if (this.validateForm(number-1)){
        this.stepper_count = number
        if(number === 3){
          this.set_clients = true
        }
      }
    },
    validateForm(number){
      return this.$refs[`forms${number}`].validate()
    },
  },
}
</script>



